<template>
    <div class="d-flex solicitar-token-validacao-wrapper">
        <div class="d-flex align-center solicitar-token-validacao">
            <span class="solicitar-token-validacao-label">{{ label }}</span>
        </div>

        <v-switch
            class="ma-0 pa-0"
            color="primary"
            dense
            hide-details
            v-model="value.exigirTokenValidacao"
            :disabled="desabilitarCampo"
        />
    </div>

</template>

<script>
export default {
    name: 'SwitchSolicitarTokenValidacao',
    props: {
        value: {
            required: true
        },
        desabilitarCampo: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            required: true
        },
    }
}
</script>

<style lang="stylus" scoped>
.solicitar-token-validacao-wrapper
    justify-content space-between

    .solicitar-token-validacao
        gap 5px

        .solicitar-token-validacao-label
            color var(--text-color-300)
            font-size 16px
</style>
